export default __webpack_public_path__ + "static/media/pic2-nobg.a071f9f9.png";